import { isUserLoggedIn } from "@/auth/utils";

export default [
    {
        // Old inbox, redirect to new messaging-inbox
        path: "/inbox/:chatId?",
        redirect: {
            name: "messaging-inbox",
        },
    },
    {
        name: "messaging-inbox",
        path: "/messaging-inbox/:chatId?",
        component: () => import(`@/views/modules/messaging-inbox/messagingInbox.vue`),
        meta: {
            contentRenderer: "sidebar-left",
            contentClass: "chat-application",
            navActiveLink: "messaging-inbox",
            resource: "inbox",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
];
